import {Link, Outlet} from "react-router-dom";
import {Layout, Row, Col, Avatar, Popover, Button} from 'antd';
import { useAuth0 } from "@auth0/auth0-react";

const {Content, Header} = Layout;

export default function BaseLayout() {
    const { user, isAuthenticated, isLoading, logout } = useAuth0();
    let avatar = null;
    if(isLoading || !isAuthenticated) {
        avatar = <Avatar style={{backgroundColor:'#bfbfbf'}}>?</Avatar>
    }
    else {
        avatar = <span style={{color:'#ffffff', cursor: 'pointer'}}>
            <Popover content={<Button onClick={() => logout({ logoutParams: { returnTo: '/' } })}>Logout</Button>} title="Profile options" trigger="click">
                <Avatar style={{backgroundColor:'#bfbfbf'}}>{user.name.charAt(0).toUpperCase()}</Avatar>&nbsp;&nbsp;{user.name}
            </Popover>
        </span>;
    }

    return (
        <Layout style={{minHeight: "100vh", paddingBottom: '32px'}}>
            <Header style={{display: 'flex', width: '100%'}}>
                <Row gutter={16}>
                    <Col className="gutter-row" span={20}>
                        <div>
                            <div className="logo" style={{color: '#ffffff', fontWeight: 'bold'}}>
                                <Link to={'/'} style={{color: '#ffffff'}}>BERGER auto import</Link>
                            </div>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={4} style={{alignItems: 'flex-end'}}>
                        {avatar}
                    </Col>
                </Row>
            </Header>
            <Content style={{display: 'flex', maxWidth: '1200px', width: '100%', margin: 'auto', paddingTop: '50px', flexDirection: 'column'}}>
                <Outlet/>
            </Content>
        </Layout>
    );
}